import React from 'react';
import { bool, node, number } from 'prop-types';

const NWShowMore = ({ children, limit = 1, showAll }) => {
  if (!React.Children.count(children)) return null;

  const visibleChildren = showAll ? children : React.Children.toArray(children).slice(0, limit);

  return <>{visibleChildren}</>;
};

NWShowMore.propTypes = {
  children: node,
  showAll: bool,
  limit: number,
};

export { NWShowMore };
